import {CommunityFooter, type CommunityFooterProps} from '../../generic/CommunityFooter/CommunityFooter'
import {MonaFooter, type MonaFooterProps} from '../../generic/MonaFooter/MonaFooter'

import Styles from './FooterSection.module.css'

export interface FooterSectionProps {
  monaFooter: MonaFooterProps
  communityFooter: CommunityFooterProps
}

export type FooterSectionPropsData = Omit<FooterSectionProps, 'monaFooter'> & {
  monaFooter: {
    repos: Omit<MonaFooterProps['repos'], 'items'>
  }
}

export const defaultProps: Partial<FooterSectionProps> = {}

export const FooterSection = (props: FooterSectionProps) => {
  const initializedProps: FooterSectionProps = {...defaultProps, ...props}
  const {monaFooter, communityFooter} = initializedProps

  return (
    <div className={Styles['FooterSection']}>
      <MonaFooter {...monaFooter} />
      <CommunityFooter {...communityFooter} />

      <div className={Styles['FooterSection__Spacer']} />
    </div>
  )
}
